type NullableString = string | null | undefined;

export function stringNullComparator(a: NullableString, b: NullableString): number {
  // normalize
  const ax = (a ?? '').trim();
  const bx = (b ?? '').trim();

  return ax.localeCompare(bx);
}
